import React, { useEffect, useState } from 'react'
import "./LiveAds.css"
import HeadingSection from '../Campaign/HeadingSection/HeadingSection'
import LiveAdsCard from './LiveAdsCard/LiveAdsCard'
import { useDispatch, useSelector } from 'react-redux'
import { stepsActions } from '../../store/steps-slice'
import NoLiveAds from './NoLiveAds'
import { PuffLoader } from "react-spinners"
import UNIVERSAL from '../../config/config'
const LiveAds = () => {
  //window.location.reload(false);
  const [liveAdsdata, setLiveAdsData] = useState();
  const [adsData, setAdsData] = useState(false);
  const user = useSelector(state => state.user.user)
  const [loadSpinner, setLoadSpinner] = useState(true);
  const [state, setState] = useState(null);
  //useSelector((state)=>state.steps.loadingSpinner);
  const dispatch = useDispatch();


  useEffect(() => {
    async function getLiveAdsData() {
      dispatch(stepsActions.handleLoadingSpinner(true));
      //setAdsData(false);
      return fetch(UNIVERSAL.BASEURL_1 + '/campaigns/v3/listCampaign', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': '6gZ2J0WfUx9iAmKIwvwG3NiX1783yn094tzrssHe',
        },
        body: JSON.stringify({
          "businessId": user?.app_business_id,
          "group_by": "AD_STATUS"
        })
      })
        .then((response) => response.json())
        .then((responseJson) => {
          if (responseJson.data.length > 0) {
            setLiveAdsData(responseJson.data[0].ad_preview_data);
            setLoadSpinner(false);
          } else {
            // error
            setLoadSpinner(false);
            setAdsData(true);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    };
    getLiveAdsData();
  }, [])

  useEffect(() => {
    const savedState = JSON.parse(localStorage.getItem('live-ads'));
    if (savedState) {
      setState(savedState);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('live-ads', JSON.stringify(state));
  }, [state]);

  return (

    <div id='live-ads'>
      <HeadingSection heading="Running ads" note="Check out the list of running ads" />
      {loadSpinner && <div className="puffLoadingSpinner">
        <PuffLoader size={100} color="#0F6EFF" />
      </div>}
      {!loadSpinner && (
        (adsData === true) ? <NoLiveAds /> :
          <div id="LiveAdsCards">
            {liveAdsdata?.map((data, index) => {
              return <LiveAdsCard data={data} key={index} />
            })}
          </div>
      )
      }
    </div>
  )
}

export default LiveAds